import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'STATICDATAGENERAL/';

export const INITIALISE = `${pre}INITIALISE`;
export const LOADING = `${pre}LOADING`;
export const SET_MONITOR_ROWS = `${pre}SET_MONITOR_ROWS`;
export const FETCH_MONITOR_ROWS_FAILED = `${pre}FETCH_MONITOR_ROWS_FAILED`;
export const ADD_CSA_TO_ACADIA_SOFT = `${pre}ADD_CSA_TO_ACADIA_SOFT`;
export const ADD_CSA_TO_ACADIA_SOFT_SUCCESS = `${pre}ADD_CSA_TO_ACADIA_SOFT_SUCCESS`;
export const ADD_CSA_TO_ACADIA_SOFT_ERROR = `${pre}ADD_CSA_TO_ACADIA_SOFT_ERROR`;
export const DELETE_CSA_FROM_ACADIA_SOFT = `${pre}DELETE_CSA_TO_ACADIA_SOFT`;
export const DELETE_CSA_FROM_ACADIA_SOFT_SUCCESS = `${pre}DELETE_CSA_TO_ACADIA_SOFT_SUCCESS`;
export const DELETE_CSA_FROM_ACADIA_SOFT_ERROR = `${pre}DELETE_CSA_TO_ACADIA_SOFT_ERROR`;

subscribe(FETCH_MONITOR_ROWS_FAILED, 'Failed to load static data monitoring csa rows', notificationError);
subscribe(ADD_CSA_TO_ACADIA_SOFT_ERROR, 'Failed to add csa to Acadiasoft', notificationError);
subscribe(DELETE_CSA_FROM_ACADIA_SOFT_ERROR, 'Failed to add csa to Acadiasoft', notificationError);

export const initialise = () => ({
    type: INITIALISE
});

export const setLoading = () => ({
    type: LOADING
});

export const setRows = rows => ({
    type: SET_MONITOR_ROWS,
    rows
});

export const fetchMonitorRowsFailed = () => ({
    type: FETCH_MONITOR_ROWS_FAILED
});

export const addToAcadiaSoft = (csa, checked, id) => ({
    type: ADD_CSA_TO_ACADIA_SOFT,
    csa,
    checked,
    id
});

export const addToAcadiaSoftSuccess = () => ({
    type: ADD_CSA_TO_ACADIA_SOFT_SUCCESS
});

export const addToAcadiaSoftError = error => ({
    type: ADD_CSA_TO_ACADIA_SOFT_ERROR,
    error
});
